module.exports = __webpack_public_path__ + "static/media/remove.4f655642.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/remove.png
// module id = 1242
// module chunks = 0